// extracted by mini-css-extract-plugin
export default {"wrapper":"Resolution_wrapper__5q0TH"};